module.exports = __webpack_public_path__ + "img/advantagesImg5.81586fee.png";